import React from 'react';
import { Switch, Route } from 'react-router';
import RouteGetter from '../../../routes/RouteGetter';
import ActivityPage from './ActivityPage';


const Activity = () => {
  return (
    <Switch>
      <Route exact path={RouteGetter.get('project').activityPath()}>
        <ActivityPage />
      </Route>
    </Switch>
  );
};

export default Activity;
